<header class="ion-header ion-hide-lg-up">
  <header-main></header-main>
</header>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1>
      <svg xmlns="http://www.w3.org/2000/svg" class="ion-icon" viewBox="0 0 512 512"><path d="M240 480v-36.42C160.53 439 112.25 398.06 112 336h72c1.77 26.34 23.86 46.45 56 50v-98l-26.77-7c-61-14.18-93.64-49.39-93.64-102.08C119.59 116.81 164.08 76.08 240 70V32h32v38c77.39 6.3 119 47.74 120 106h-72c-.76-24.06-15.83-43.39-48-46v92l30.82 7.28C367.61 243.46 400 277 400 332c0 64.34-43.74 105.88-128 111.32V480zm0-264v-86c-27.59 1.52-47.27 18.47-47.27 42.53 0 22.3 16.39 36.88 47.27 43.47zm32 78v92c38.15-1.54 56.38-18.92 56.38-45.77 0-24.58-18.23-41.13-56.38-46.23z"/></svg>
      Pricing
    </h1>
  </header>
  
  <div class="container ion-grid ion-padding">
    <div class="sub-heading">
      <h2>Check out our fair pricing</h2>
    </div>
  </div>

  <div class="container ion-grid ion-padding">
    <div class="row pricing ion-justify-content-end">
      <div class="col col-xs-12" [ngClass]="guest.length ? 'col-sm-4' : 'col-sm-6'">
        <div class="pricing-heading bg-tertiary" (click)="showLaunch = !showLaunch" [ngClass]="{'active': !showLaunch}">
          <h3>
            Pricing
            <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.19 29.19"><defs><style>.arrow-right{fill:inherit;stroke:none;}</style></defs><title>arrow-right</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="arrow-right" d="M14.6,29.19a14.6,14.6,0,1,1,14.59-14.6A14.62,14.62,0,0,1,14.6,29.19ZM14.6,1a13.6,13.6,0,0,0,0,27.19h0A13.6,13.6,0,0,0,14.6,1Z"/><path class="arrow-right" d="M13.07,19.73a1,1,0,0,1-.76-.35A1,1,0,0,1,12.42,18l4-3.38-4-3.37a1,1,0,0,1-.11-1.41,1,1,0,0,1,1.4-.12l4.88,4.14a1,1,0,0,1,0,1.53L13.71,19.5A1,1,0,0,1,13.07,19.73Z"/></g></g></svg>
          </h3>
        </div>

        <div class="pricing-heading-content" [ngClass]="{'active': !showLaunch}">
          <div class="row ion-justify-content-center" *ngFor="let type of types; let i = index">
            <div class="col col-xs-6 pricing-types-sm">
              {{type}}
            </div>
            <div class="col col-xs-6 bg-tertiary-light">
              {{ member[i] }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="guest.length > 0" class="col col-xs-12 col-sm-4">
        <div class="pricing-heading bg-secondary" (click)="showFinal = !showFinal" [ngClass]="{'active': showFinal}">
          <h3>
            Non Member
            <small>(no subscription fee)</small>
            <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.19 29.19"><defs><style>.arrow-right{fill:inherit;stroke:none;}</style></defs><title>arrow-right</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="arrow-right" d="M14.6,29.19a14.6,14.6,0,1,1,14.59-14.6A14.62,14.62,0,0,1,14.6,29.19ZM14.6,1a13.6,13.6,0,0,0,0,27.19h0A13.6,13.6,0,0,0,14.6,1Z"/><path class="arrow-right" d="M13.07,19.73a1,1,0,0,1-.76-.35A1,1,0,0,1,12.42,18l4-3.38-4-3.37a1,1,0,0,1-.11-1.41,1,1,0,0,1,1.4-.12l4.88,4.14a1,1,0,0,1,0,1.53L13.71,19.5A1,1,0,0,1,13.07,19.73Z"/></g></g></svg>
          </h3>
        </div>

        <div class="pricing-heading-content" [ngClass]="{'active': showFinal}">
          <div class="row ion-justify-content-center" *ngFor="let type of types; let i = index">
            <div class="col col-xs-6 pricing-types-sm">
              {{type}}
            </div>
            <div class="col col-xs-6 bg-secondary-light">
              {{ guest[i] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pricing-lg pricing-row ion-justify-content-center ion-align-items-center" *ngFor="let type of types; let i = index">
      <div class="col col-xs-4 pricing-types" [ngClass]="guest.length ? 'col-sm-4' : 'col-sm-6'">
        <div class="pricing-content">
          {{type}}
        </div>
      </div>

      <div class="col col-xs-4" [ngClass]="guest.length ? 'col-sm-4' : 'col-sm-6'">
        <div class="pricing-content bg-tertiary-light">
          {{ member[i] }}
        </div>
      </div>

      <div *ngIf="guest.length > 0" class="col col-xs-4 col-sm-4">
        <div class="pricing-content bg-secondary-light">
          {{ guest[i] }}
        </div>
      </div>
    </div>

    <p class="pricing-note">
      <small>*Gig Work 5% commission coming soon for members</small><br />
      <small>All Gig Workers require prior Identity authorisation via our KYC API</small><br />
      <small>All NZ citizens/residents subject to 15% GST FEES on top of Gig Work commission</small><br />
      <small>All gig prices and job salaries are shown in local listing currency</small><br />
      <small>All remote gigs are shown in origin gig lister currency and paid out in gig worker local currency</small><br />
    </p>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
